import React, { Component } from 'react';
import LoadingCircle from './LoadingCircle';

export default class Loading extends Component {
  static defaultProps = {
    width: '10px',
    height: '10px'
  };

  render() {
    return <LoadingCircle {...this.props} />;
  }
}
